import React from 'react';
import { apiVariables } from '../utils/variables';
import {Navbar, Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
/* eslint eqeqeq: "off", no-unused-expressions: "off"*/



export class NavBar extends React.Component{
    constructor(props){
        super(props);
        this.updateSelected = this.updateSelected.bind(this);
        
    }
    updateSelected(organization){
        this.props.updateSelected(organization);
    }
    render(){
        return (
            <Navbar collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="/">Solution Monitor</a>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <NavItem eventKey={1} href="/state">
                            Solution State
                        </NavItem>
                        <NavItem eventKey={2} href="/events">
                            Events
                        </NavItem>
                        <NavItem eventKey={3} href="/about">
                            About
                        </NavItem>
                        <NavItem eventKey={4} href="/profile">
                            {this.props.username}
                        </NavItem>
                    </Nav>
                    <Nav pullRight>
                        <NavItem eventKey={1} onClick={() => logout()}>
                            Sign Out
                        </NavItem>
                        <NavDropdown eventKey={2} title={this.props.CurrentOrganization} id="basic-nav-dropdown">
                            {this.props.organizations.map((organization =>
                                <MenuItem key={organization.organization} onClick={() => this.updateSelected(organization.organization)}>{organization.organization}</MenuItem>
                            ))}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
                
            </Navbar>
            
        );
    }
}

async function logout(){
    await fetch(apiVariables.apiLink + "/logout", {
        method: "POST",
        headers: apiVariables.headers,
        credentials: apiVariables.credentials
    })
    window.location.reload()
}


// WEBPACK FOOTER //
// ./src/pages/navbar.js